const actionTypes = {
    USER_NAME :'username'
}
export default actionTypes;


// WEBPACK FOOTER //
// ./src/store/constant/constants.js